import {gql} from '@apollo/client'

export const EMPLOYEE_DEPENDENTS = gql`
  query employeeDependents($employeeId: ID!, $dependentIds: [ID!]) {
    client {
      employee(employeeId: $employeeId) {
        employeeDependentsWhereByIds(dependentIds: $dependentIds) {
          id
          firstName
          lastName
          firstNameKana
          lastNameKana
          birthday
          gender
          relationType
          residenceStatus
          domesticRemittance
          remittance
          prefecture {
            id
          }
          postcode0
          postcode1
          city
          houseNumber
          building
          addressKana
          addressForeign
          job
          phoneNumber0
          phoneNumber1
          phoneNumber2
          basicPensionNumber0
          basicPensionNumber1
          nationalType
          romajiName
          romajiNameKana
          relationName
          relationReportType
          annualIncome
          annualEarnings
          handicapType
          handicapDetail
          handicapCertificate
          isNonResident
          isStudyAbroad
          relatedToRelativesDocument
          relatedToRemittanceDocument
          provingStudyAbroadDocument
          dependentSocialInsurance
          dependentFrom
          dependentReason
          dependentTaxLaw
          dependentTaxLawFrom
          dependentTaxLawReason
        }
      }
    }
  }
`

export interface EmployeeDependentVars {
  employeeId: string
  dependentIds: string[]
}

export interface EmployeeDependentData {
  client: {
    employee: EmployeeDependent[]
  }
}

interface Prefecture {
  id: string
}

interface File {
  filename: string
  url: string
}

interface EmployeeDependent {
  id: number | null
  firstName: string | null
  lastName: string | null
  firstNameKana: string | null
  lastNameKana: string | null
  birthday: string | null
  gender: string | null
  relationType: 'spouse' | 'other' | null
  relationReportType: 'parents' | 'child' | 'other' | 'real_child_or_adopted_child' | 'other_child' | null
  residenceStatus: 'same_address' | 'different_address' | 'different_and_foreign_address' | null
  domesticRemittance: number | null
  remittance: number | null
  prefecture: Prefecture | null
  postcode0: string | null
  postcode1: string | null
  city: string | null
  houseNumber: string | null
  building: string | null
  addressKana: string | null
  addressForeign: string | null
  job: string | null
  phoneNumber0: string | null
  phoneNumber1: string | null
  phoneNumber2: string | null
  basicPensionNumber0: string | null
  basicPensionNumber1: string | null
  nationalType: 'japanese' | 'foreigner' | null
  romajiName: string | null
  romajiNameKana: string | null
  relationName: string | null
  dependentReason: string | null
  annualIncome: number | null
  annualEarnings: number | null
  handicapType: 'none' | 'normal' | 'special' | null
  handicapDetail: string | null
  handicapCertificate: File | null
  dependentTaxLaw: boolean | null
  isNonResident: boolean | null
  isStudyAbroad: boolean | null
  relatedToRelativesDocument: File | null
  relatedToRemittanceDocument: File | null
  provingStudyAbroadDocument: File | null
}

export const CHILDCARE_PROCEDURE_STATUS_ON_ADD_DEPENDENTS = gql`
  query childcareProcedureStatusOnAddDependents($procedureStatusId: ID!) {
    client {
      id
      procedureStatus(procedureStatusId: $procedureStatusId) {
        id
        procedureChildcareDatum {
          id
          procedureChildcareChildDatum {
            id
            firstName
            firstNameKana
            lastName
            lastNameKana
            birthDate
          }
        }
      }
    }
  }
`
